import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../context/UserContext';
import './TimelineGallery.css';

const TimelineGallery = () => {
  const { userTimelines, createTimeline, updateTimeline, deleteTimeline, currentUser, logout } = useUserContext();
  const navigate = useNavigate();
  const [newTimelineName, setNewTimelineName] = useState('');
  const [confirmingDeleteId, setConfirmingDeleteId] = useState(null);
  const [renamingTimelineId, setRenamingTimelineId] = useState(null);
  const [renameTimelineName, setRenameTimelineName] = useState('');
  
  const handleCreateNew = (e) => {
    e.preventDefault();
    const name = newTimelineName.trim();
    if (name) {
      const timelineId = createTimeline(name);
      setNewTimelineName('');
      navigate(`/timeline/${timelineId}`);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const startRename = (timeline) => {
    setConfirmingDeleteId(null);
    setRenamingTimelineId(timeline.id);
    setRenameTimelineName(timeline.name);
  };

  const cancelRename = () => {
    setRenamingTimelineId(null);
    setRenameTimelineName('');
  };

  const handleRename = (e, timelineId) => {
    e.preventDefault();
    const name = renameTimelineName.trim();
    if (!name) return;

    updateTimeline(timelineId, { name });
    cancelRename();
  };

  return (
    <div className="gallery-page">
      <div className="gallery-header">
        <div className="gallery-brand">
          <img src="/agora-temple.png" alt="" className="gallery-logo" aria-hidden="true" />
          <div className="gallery-brand-text">
            <span>Agora Timeline</span>
            <h1>My Timelines</h1>
          </div>
        </div>
        <div className="user-controls">
          <span>User: {currentUser.id}</span>
          <button onClick={handleLogout}>Logout</button>
        </div>
      </div>
      
      <div className="timeline-grid">
        {userTimelines.map(timeline => (
          <div key={timeline.id} className="timeline-card" data-tutorial-id="saved-timeline-card">
            <h3>{timeline.name}</h3>
            <p>{timeline.events?.length || 0} events</p>
            {renamingTimelineId === timeline.id ? (
              <form className="rename-timeline-form" onSubmit={(e) => handleRename(e, timeline.id)}>
                <label htmlFor={`rename-timeline-${timeline.id}`}>Timeline name</label>
                <input
                  id={`rename-timeline-${timeline.id}`}
                  type="text"
                  value={renameTimelineName}
                  onChange={(e) => setRenameTimelineName(e.target.value)}
                  autoFocus
                />
                <div className="card-actions">
                  <button type="button" onClick={cancelRename} className="cancel-btn">
                    Cancel
                  </button>
                  <button type="submit" className="open-btn" disabled={!renameTimelineName.trim()}>
                    Save
                  </button>
                </div>
              </form>
            ) : confirmingDeleteId === timeline.id ? (
              <div className="delete-confirmation">
                <p>Delete this timeline?</p>
                <div className="card-actions">
                  <button
                    type="button"
                    onClick={() => setConfirmingDeleteId(null)}
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      deleteTimeline(timeline.id);
                      setConfirmingDeleteId(null);
                    }}
                    className="delete-btn"
                  >
                    Confirm Delete
                  </button>
                </div>
              </div>
            ) : (
              <div className="card-actions">
                <button 
                  onClick={() => navigate(`/timeline/${timeline.id}`)}
                  className="open-btn"
                  data-tutorial-id="open-timeline"
                >
                  Open
                </button>
                <button
                  type="button"
                  onClick={() => startRename(timeline)}
                  className="rename-btn"
                >
                  Rename
                </button>
                <button 
                  onClick={() => setConfirmingDeleteId(timeline.id)}
                  className="delete-btn"
                >
                  Delete
                </button>
              </div>
            )}
          </div>
        ))}
        
        <form className="timeline-card new-card" onSubmit={handleCreateNew} data-tutorial-id="new-timeline-form">
          <div className="new-card-content">
            <span className="plus">+</span>
            <label htmlFor="new-timeline-name">Create New Timeline</label>
            <input
              id="new-timeline-name"
              type="text"
              value={newTimelineName}
              onChange={(e) => setNewTimelineName(e.target.value)}
              placeholder="Timeline name"
            />
            <button type="submit" disabled={!newTimelineName.trim()}>
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TimelineGallery; 
